import { render, staticRenderFns } from "./_taskEvent.vue?vue&type=template&id=c4353670&scoped=true"
import script from "./_taskEvent.vue?vue&type=script&lang=js"
export * from "./_taskEvent.vue?vue&type=script&lang=js"
import style0 from "./_taskEvent.vue?vue&type=style&index=0&id=c4353670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4353670",
  null
  
)

export default component.exports